import React, { useEffect, useRef, useState } from 'react'
import './create-elements-landing.styles.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faCloudUpload, faFireAlt, faInfoCircle, faMapMarkerAlt, faQuestionCircle, faRightLong } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { membershipRestrictions } from '@/utils/membershipRestrictions';
import Modal from '@/components/modal/modal.component';

const CreateElementsLanding = ({ gameData, gameElements }) => {

  const membership = useSelector(state => state.userData.membership);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [access, setAccess] = useState([]);
  const [displayInfo, setDisplayInfo] = useState(null);
  const [elementInfo] = useState({
    'badges': 'Badges are credentials that can be distributed by the ' +
      'game manager or they can be earned by completing Challenges.',
    'challenges': 'Challenges are one-off tasks that can be completed ' +
      'by players to earn XP, Currency, or other game elements. ' +
      'Players can submit text and also upload content.',
    'quests': 'Quest are multi-step collections of challenges that ' +
      'players can complete in a prescribed path. Rewards can be earned ' +
      'at each checkpoint.',
    'secretcodes': 'When players find and input Secret Codes, they can earn ' +
      'XP, Currency, and other game elements.',
    'riskcards': 'Risk Cards are interactive items that can be distributed by ' +
      'the game manager or they can be earned by completing Challenges, ' +
      'completing Quests, or by finding Secret Codes. These Cards will give ' +
      'or remove Currency or Items from a Player\'s inventory.',
    'bossbattles': 'Boss Battles are one-off events, run by the Game Manager ' +
      'that pit players or teams against an opponent.',
    'investments': 'Investments allow players to invest currency in the number ' +
      'of times Challenges or Quests will be completed, levels will be earned, ' +
      'and items will be earned or purchased.',
    'leaderboards': 'Leaderboards allow Game Managers to create rankings of ' +
      'players or teams based on their own set of conditions.',
    'levels': 'Levels are earned by players when they reach a certain XP threshold. ' +
      'Players can be rewarded with Currency or other Game Elements when they ' +
      'reach each level.',
    'collections': 'Collections are groups of Items. When players earn all ' +
      'of the Items in a Collection, they can earn XP, Currency, or other Game Elements.',
    'items': 'Items are rewards earned by Players. They can be Inventory Items ' +
      'which are used as a game mechanic, Real World Items, Collectible Items, ' +
      'Lottery Tickets, or Player-Choice Contributions.',
    'prizepacks': 'Prize Packs are collections of Items that, when earned, ' +
      'distribute a number of chosen Items to the Player.'
  });
  const accessRef = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!gameData) return;
    const pageTitleEl = document.getElementById('page-title');
    if (pageTitleEl) {
      pageTitleEl.innerText = 'Manage Game Elements';
    }
  }, [gameData])

  useEffect(() => {
    if (!gameData || !membership || !membershipRestrictions) return;
    if (
      gameData.access.includes('badges') ||
      gameData.access.includes('challenges') ||
      gameData.access.includes('quests') ||
      gameData.access.includes('secretCodes')
    ) {
      accessRef.current.push('interactives');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'interactives');
    }
    if (
      gameData.access.includes('levels') ||
      gameData.access.includes('leaderboards')
    ) {
      accessRef.current.push('pointsLeaderboards');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'pointsLeaderboards');
    }
    if (
      gameData.access.includes('collections') ||
      gameData.access.includes('items') ||
      gameData.access.includes('prizepacks')
    ) {
      accessRef.current.push('currencyMarketplace');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'currencyMarketplace');
    }
    if (
      gameData.access.includes('badges') &&
      !membershipRestrictions[membership.membership].blocked.includes('badges')
    ) {
      accessRef.current.push('badges');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'badges');
    }
    if (
      gameData.access.includes('challenges') &&
      !membershipRestrictions[membership.membership].blocked.includes('challenges')
    ) {
      accessRef.current.push('challenges');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'challenges');
    }
    if (
      gameData.access.includes('quests') &&
      !membershipRestrictions[membership.membership].blocked.includes('quests')
    ) {
      accessRef.current.push('quests');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'quests');
    }
    if (
      gameData.access.includes('secretCodes') &&
      !membershipRestrictions[membership.membership].blocked.includes('secretCodes')
    ) {
      accessRef.current.push('secretCodes');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'secretCodes');
    }
    if (
      gameData.access.includes('riskCards') &&
      !membershipRestrictions[membership.membership].blocked.includes('riskCards')
    ) {
      accessRef.current.push('riskCards');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'riskCards');
    }
    if (
      gameData.access.includes('bossBattles') &&
      !membershipRestrictions[membership.membership].blocked.includes('bossBattles')
    ) {
      accessRef.current.push('bossBattles');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'bossBattles');
    }
    if (
      gameData.access.includes('investments') &&
      !membershipRestrictions[membership.membership].blocked.includes('investments')
    ) {
      accessRef.current.push('investments');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'investments');
    }
    if (
      gameData.access.includes('leaderboards') &&
      !membershipRestrictions[membership.membership].blocked.includes('leaderboards')
    ) {
      accessRef.current.push('leaderboards');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'leaderboards');
    }
    if (
      gameData.access.includes('levels') &&
      !membershipRestrictions[membership.membership].blocked.includes('levels')
    ) {
      accessRef.current.push('levels');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'levels');
    }
    if (
      gameData.access.includes('collections') &&
      !membershipRestrictions[membership.membership].blocked.includes('collections')
    ) {
      accessRef.current.push('collections');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'collections');
    }
    if (
      gameData.access.includes('items') &&
      !membershipRestrictions[membership.membership].blocked.includes('items')
    ) {
      accessRef.current.push('items');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'items');
    }
    if (
      gameData.access.includes('prizepacks') &&
      !membershipRestrictions[membership.membership].blocked.includes('prizepacks')
    ) {
      accessRef.current.push('prizepacks');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'prizepacks');
    }
    if (
      gameData.access.includes('momentum') &&
      !membershipRestrictions[membership.membership].blocked.includes('momentum')
    ) {
      accessRef.current.push('momentum');
    } else {
      accessRef.current = accessRef.current.filter(a => a !== 'momentum');
    }
    setAccess(accessRef.current);
  }, [gameData, membership, membershipRestrictions]);

  const openUpgrade = () => {
    const newTabUrl = '/pricing'; // Replace with your desired URL
    window.open(newTabUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='create-elements-landing'>
      <div className='g-card elements-card'>
        <BackButton cancel={() => navigate(`${location.pathname.includes('/preview/manager/')
            ? '/preview/manager'
            : '/manage'
          }/${gameData.path}`)} />
        <div className="g-space-1"></div>
        <div className='card-title'>
          Create Game Elements
          {/* <button className='g-button med-btn'><FontAwesomeIcon icon={faCloudUpload} />Import Content</button> */}
        </div>
        <hr />
        {
          (membership && membership.membership === 0) &&
          <div className='g-list-item upgrade-box'>
            <p>Want access to ALL of Gamably's features? </p>
            <div>
              <button
                className='g-button med-btn primary'
                onClick={() => openUpgrade()}
              >
                Upgrade Here!
              </button>
            </div>
          </div>
        }
        {
          (access.includes('interactives')) &&
          <>
            <h4>Player Interactives</h4>
            <div className={`content-boxes ${screenSize}`}>
              {
                (access.includes('badges')) &&
                <div className={`g-list-item element-div`} >
                  <ImageContainer
                    src='/images/icons/badges.png'
                    alt='badges icon'
                    className='head-icon' />
                  <div className='item-title'>
                    <b>Badges</b>
                    {
                      (screenSize !== 'mobile') &&
                      <div className='g-space-0-5'></div>
                    }
                    <div className='meta count'>Count: {
                      gameData.createdBadges
                        ? `${gameData.createdBadges}`
                        : '0'
                    }</div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo('badges')}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate('badges')}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
              {
                (access.includes('challenges')) &&
                <div
                  className='g-list-item element-div' >
                  <ImageContainer
                    src='/images/icons/challenge.png'
                    alt='challenge icon'
                    className='head-icon' />
                  <div className='item-title'>
                    <b>Challenges</b>
                    {
                      (screenSize !== 'mobile') &&
                      <div className='g-space-0-5'></div>
                    }
                    <div className='meta count'>Count: {
                      gameData.createdChallenges
                        ? `${gameData.createdChallenges}`
                        : '0'
                    }</div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo('challenges')}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate('challenges')}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
              {
                (access.includes('quests')) &&
                <div className='g-list-item element-div'>
                  <ImageContainer
                    src='/images/icons/quests.png'
                    alt='quests icon'
                    className='head-icon' />
                  <div className='item-title'>
                    <b>Quests</b>
                    {
                      (screenSize !== 'mobile') &&
                      <div className='g-space-0-5'></div>
                    }
                    <div className='meta count'>Count: {
                      gameData.createdQuests
                        ? `${gameData.createdQuests}`
                        : '0'
                    }</div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo('quests')}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate('quests')}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
              {
                (access.includes('secretCodes')) &&
                <div className='g-list-item element-div' >
                  <ImageContainer
                    src='/images/icons/secret2.png'
                    alt='secret codes icon'
                    className='head-icon' />
                  <div className='item-title'>
                    <b>Secret Codes</b>
                    {
                      (screenSize !== 'mobile') &&
                      <div className='g-space-0-5'></div>
                    }
                    <div className='meta count'>
                      Count: {
                        gameData.createdSecretCodes
                          ? `${gameData.createdSecretCodes}`
                          : '0'
                      }
                    </div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo('secretcodes')}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate('secretcodes')}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
              {
                (access.includes('momentum')) &&
                <div className='g-list-item element-div'>
                  <ImageContainer
                    src='/images/icons/momentum.png'
                    alt='momentum cards icon'
                    className='head-icon' />
                  <div className='item-title'>
                    <b>Momentum Cards</b>
                    <div className='meta count'>
                      Count: {
                        gameData.createdMomentum
                          ? `${gameData.createdMomentum}`
                          : '0'
                      }
                    </div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo(`momentum`)}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate(`/manage/${gameData.path}/elements/momentum`)}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
              {
                (access.includes('bossbattles')) &&
                <div className='g-list-item element-div disabled'>
                  <FontAwesomeIcon
                    icon={faFireAlt}
                    size='xl'
                    style={{ 'color': 'var(--boss-color)' }} />
                  <div className='item-title'>
                    <b>Boss Battles</b>
                    {
                      (screenSize !== 'mobile') &&
                      <div className='g-space-0-5'></div>
                    }
                    <div className='meta count'>
                      Count: {gameData.createdBossBattles ? `${gameData.createdBossBattles}` : '0'}
                    </div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo('bossbattles')}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate('bossbattles')}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
              {
                (access.includes('investments')) &&
                <div className='g-list-item element-div disabled'>
                  <FontAwesomeIcon
                    icon={faChartLine}
                    size='xl'
                    style={{ 'color': 'var(--level-color)' }} />
                  <div className='item-title'>
                    <b>Investments</b>
                    {
                      (screenSize !== 'mobile') &&
                      <div className='g-space-0-5'></div>
                    }
                    <div className='meta count'>
                      Count: {gameData.createdInvestments ? `${gameData.createdInvestments}` : '0'}
                    </div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo('investments')}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate('investments')}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
            </div>
          </>
        }
        {
          (access.includes('pointsLeaderboards')) &&
          <>
            <h4>Points and Leaderboard Features</h4>
            <div className={`content-boxes ${screenSize}`}>

              {
                (access.includes('leaderboards')) &&
                <div className='g-list-item element-div'>
                  <ImageContainer
                    src='/images/icons/leaderboard.png'
                    alt='leaderboards icon'
                    className='head-icon' />
                  <div className='item-title'>
                    <b>Leaderboards</b>
                    {
                      (screenSize !== 'mobile') &&
                      <div className='g-space-0-5'></div>
                    }
                    <div className='meta count'>
                      Count: {
                        gameData.createdLeaderboards
                          ? `${gameData.createdLeaderboards}`
                          : '0'
                      }
                    </div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo('leaderboards')}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate(`/manage/${gameData.path}/leaderboards`)}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
              {
                (access.includes('levels')) &&
                <div className='g-list-item element-div'>
                  <ImageContainer
                    src='/images/icons/levels3.png'
                    alt='levels icon'
                    className='head-icon' />
                  <div className='item-title'>
                    <b>Levels</b>
                    {
                      (screenSize !== 'mobile') &&
                      <div className='g-space-0-5'></div>
                    }
                    <div className='meta count'>
                      Count: {
                        gameData.createdLevels
                          ? `${gameData.createdLevels}`
                          : '0'
                      }
                    </div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo('levels')}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate('levels')}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
            </div>
          </>
        }
        {
          (access.includes('currencyMarketplace')) &&
          <>
            <h4>Marketplace Features</h4>
            <div className={`content-boxes ${screenSize}`}>

              {
                (accessRef.current.includes('items')) &&
                <div className='g-list-item element-div'>
                  <ImageContainer
                    src='/images/icons/items.png'
                    alt='items icon'
                    className='head-icon' />
                  <div className='item-title'>
                    <b>Items</b>
                    {
                      (screenSize !== 'mobile') &&
                      <div className='g-space-0-5'></div>
                    }
                    <div className='meta count'>
                      Count: {gameData.createdItems ? `${gameData.createdItems}` : '0'}
                    </div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo('items')}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate('items')}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
              {
                (access.includes('collections')) &&
                <div className='g-list-item element-div'>
                  <ImageContainer
                    src='/images/icons/collections.png'
                    alt='collections icon'
                    className='head-icon' />
                  <div className='item-title'>
                    <b>Collections</b>
                    {
                      (screenSize !== 'mobile') &&
                      <div className='g-space-0-5'></div>
                    }
                    <div className='meta count'>
                      Count: {gameData.createdCollections ? `${gameData.createdCollections}` : '0'}
                    </div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo('collections')}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate('collections')}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
              {
                (access.includes('prizepacks')) &&
                <div className='g-list-item element-div' >
                  <ImageContainer
                    src='/images/icons/prizepacks.png'
                    alt='prize packs icon'
                    className='head-icon' />
                  <div className='item-title'>
                    <b>Prize Packs</b>
                    <div className='meta count'>
                      Count: {gameData.createdPrizePacks ? `${gameData.createdPrizePacks}` : '0'}
                    </div>
                  </div>
                  <div className='buttons'>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => setDisplayInfo('prizepacks')}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                    <button
                      className={`g-button ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => navigate('prizepacks')}>
                      <FontAwesomeIcon icon={faRightLong} />
                    </button>
                  </div>
                </div>
              }
            </div>
          </>
        }

      </div>
      <Modal
        show={displayInfo}
        cancel={() => setDisplayInfo(null)}
        text={`What are ${displayInfo ?
            displayInfo === 'secretcodes'
              ?
              'Secret Codes'
              :
              displayInfo === 'prizepacks'
                ?
                'Prize Packs'
                :
                displayInfo === 'momentum'
                  ?
                  'Momentum Cards'
                  :
                  displayInfo.charAt(0).toUpperCase() + displayInfo.slice(1)
            : ''
          }?`}
        cls='narrow' >
        <div className='info-content'>
          <p>{displayInfo && elementInfo[displayInfo]}</p>
          <div className='g-space-1'></div>
          <div className='buttons'>
            <button
              className='g-button'
              onClick={() => setDisplayInfo(null)}>
              Close
            </button>
          </div>
        </div>
      </Modal>
    </div>

  )
}

export default CreateElementsLanding